import { render, staticRenderFns } from "./Treasure.vue?vue&type=template&id=1c2288de&scoped=true&"
import script from "./Treasure.vue?vue&type=script&lang=js&"
export * from "./Treasure.vue?vue&type=script&lang=js&"
import style0 from "./Treasure.vue?vue&type=style&index=0&id=1c2288de&lang=sass&scoped=true&"
import style1 from "./Treasure.vue?vue&type=style&index=1&id=1c2288de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2288de",
  null
  
)

export default component.exports